import React from "react";

import { FormattedDate } from "react-intl";

import { css } from "@emotion/react";
import styled from "@emotion/styled";

import LinkComponent, { Link } from "../LinkComponent";
import SmallShapeContainer from "../SmallShapeContainer";

const articleImageHeight = 150;

const articleImage = css`
    width: 100%;
    height: ${articleImageHeight}px;
`;

const ArticleImage = styled.img`
    ${articleImage}

    object-fit: cover;
`;

const ArticleImagePlaceholder = styled.div`
    ${articleImage}

    background-color: ${({ theme }) => theme.colors.red.toString()};
`;

const ArticleSubline = styled.div`
    font-size: 0.8rem;
`;

const ArticleHeadline = styled.div`
    margin: 10px 0 20px;
    font-size: 1rem;
    font-weight: 900;
    line-height: 1.2rem;
`;

const LinkItem = styled(Link)`
    width: 100%;
`;

const ArticleCard = ({ article, linkText = "Mehr erfahren", width }) => (
    <LinkItem to={`/news/${article.slug}`}>
        <SmallShapeContainer>
            <SmallShapeContainer.ImageContainer>
                {article.image ? (
                    <ArticleImage
                        src={`${article.image}?w=364`}
                        css={css`
                            object-position: ${article.titleAlignment};
                        `}
                        loading="lazy"
                        decoding="async"
                        {...{ width }}
                        height={articleImageHeight}
                    />
                ) : (
                    <ArticleImagePlaceholder />
                )}
            </SmallShapeContainer.ImageContainer>

            <SmallShapeContainer.TextContainer>
                <div>
                    <ArticleSubline>
                        <FormattedDate
                            value={article.datePublished}
                            format="short"
                        />
                    </ArticleSubline>

                    <ArticleHeadline>{article.title}</ArticleHeadline>
                </div>

                <LinkComponent
                    noLink
                    link={{
                        href: `/news/${article.slug}`,
                        text: linkText,
                    }}
                    icon="arrow-right"
                />
            </SmallShapeContainer.TextContainer>
        </SmallShapeContainer>
    </LinkItem>
);
export default ArticleCard;
